import { dayjs } from '@mobi/utils/date'

/** Format race ISO string or date to simple YYYY-MM-DD */
export function formatFixtureDateToSimpleString(dateValue: string | Date) {
  const dateUtcAwst = dayjs.utc(dateValue).utcOffset('+08:00')
  if (dateUtcAwst.isValid()) {
    return dateUtcAwst.format('YYYY-MM-DD')
  }
  return dayjs().format('YYYY-MM-DD')
}
